export default __webpack_public_path__ + "static/prong-collars-2-1d94718ea7f026bee3649c1aecea6852.jpg";